import React, { Fragment } from 'react';
import ConcessionaireTable from './ConcessionaireTable';

const ConcessionaireList = () => {
    return (
        <Fragment>
            <ConcessionaireTable />
        </Fragment>
    );
};

export default ConcessionaireList;
